import type {
  ImportChannelReservationRequestDto,
  SyncChannelRatesAvailabilityRequestDto,
} from "./contracts/dtos.ts";
import type { ChannelProvider } from "./provider.ts";
import {
  importChannelReservation,
  syncChannelRatesAndAvailability,
} from "./service.ts";
import type { ChannelManagerContext, ChannelSyncAttempt } from "./types.ts";

export const channelManagementEndpoints = {
  importReservation: (
    request: ImportChannelReservationRequestDto,
    context: ChannelManagerContext,
    deps: { idFactory: (prefix: string) => string }
  ) => importChannelReservation(request, context, deps),
  syncRatesAndAvailability: (
    request: SyncChannelRatesAvailabilityRequestDto,
    context: ChannelManagerContext & { attempts: ChannelSyncAttempt[] },
    deps: { idFactory: (prefix: string) => string; provider: ChannelProvider }
  ) => syncChannelRatesAndAvailability(request, context, deps),
};
